import { Drawer } from 'antd';
import Aside from '../Aside';

const AsideDrawer = ({ open, onClose, branding }) => {
    return (
        <Drawer
            title={branding}
            placement="left"
            styles={{
                header: {
                    maxHeight: '50px',
                },
                body: {
                    padding: 0,
                },
            }}
            onClose={onClose}
            open={open}
            classNames={{
                header: 'aside-drawer-header px-4',
            }}
            width={300}
        >
            <Aside onClose={onClose} />
        </Drawer>
    );
};

export default AsideDrawer;
